<template>
    <div class="systemNotification">
        <van-loading
            class="pageLogin"
            v-if="loading"
            type="spinner"
            color="#1989fa"
        ></van-loading>
        <section v-if="newsData">
            <van-cell
                :icon="require('@/assets/images/addressBook/goodFriend.png')"
                :title="newsData.Dispatcher"
                :value="newsData.CreateTime"
                default-date
            >
            </van-cell>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p v-html="newsData.Content"></p>
            <ul class="fileList">
                <template v-for="(item,index) in newsData.EncList">
                    <li :key="index" @click="attachmentPreview(item)">
                        <span>{{ item.FileName }}</span>
                        <i class="iconfont iconfanhui1"></i>
                    </li>
                </template>
            </ul>
            <van-divider></van-divider>
            <dl>
                <dt class="iconfont iconbeizhu">
                    签收意见
                </dt>
                <template v-for="(item,index) in newsData.SignList">
                    <dd :key="index">
                        <van-cell
                            :icon="require('@/assets/images/addressBook/goodFriend.png')"
                            :title="item.UserName"
                            :value="item.OpinionTime"
                            default-date
                        >
                        </van-cell>
                        <p>{{ item.Opinion }}</p>
                    </dd>
                </template>
            </dl>
            <van-field
                v-model="opinion"
                rows="2"
                autosize
                type="textarea"
                maxlength="80"
                class="iconfont iconbeizhu textarea"
                placeholder="请在此处填写签收意见"
            ></van-field>
            <button @click="signFor">
                发送
            </button>
        </section>
    </div>
</template>

<script>
import util from '@/assets/js/utils';

export default {
    // 系统通知
    name: 'system-notification',
    components: {},
    props: {},
    data() {
        return {
            // 消息id
            newsId: '',
            // 消息数据
            newsData: {},
            // 附件地址
            url: '',
            // 加载状态
            loading: false,
            // 签收意见
            opinion: '',
        };
    },
    computed: {},
    watch: {},
    created() {
        this.newsId = window.localStorage.getItem('systemMessageId');
        this.loading = true;
        // 拉取消息详情
        this.getDetail();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 拉取消息详情
        getDetail() {
            if (this.newsId === '') {return;}
            this.$axios
                .get('/interfaceApi/message/MessageInfo/get_detail/' + this.newsId)
                .then(res => {
                    this.getFileDetailFun(res);
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    this.$dialog({ message: error });
                });
        },
        // 获取文件下载预览地址
        getFileDetailFun(data) {
            const arr = data;
            if (arr.EncList.length > 0) {
                arr.EncList.forEach(item => {
                    item.url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${item.KeyId}/download`;
                });
            }
            this.newsData = arr;
        },
        // 附件预览
        attachmentPreview(data) {
            this.url = data.url;
            this.$router.isBack = 2;
            this.$router.push({
                name: 'messageAttachment',
                params: {
                    url: this.url,
                    isNews: true,
                },
            });
        },
        // 发送签收意见
        signFor() {
            this.$axios
                .post('/interfaceApi/message/MessageInfo/sign', {
                    Id: this.newsId,
                    Content: this.opinion,
                })
                .then(res => {
                    this.newsData.SignList.push({
                        UserName: this.$takeTokenParameters('Name'),
                        OpinionTime: util.currentTimeFormat('yyyy-MM-dd HH:mm:ss'),
                        Opinion: this.opinion,
                    });
                    this.$toast.success(res);
                    this.opinion = '';
                }).catch(error => {
                    this.$dialog({ message: error });
                });
        },
    },
};
</script>
<style lang="stylus">
.systemNotification
    height 100%
    section
        height 100%
        padding-bottom 20rpx
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .van-cell
            &:after
                display none
            .van-cell__left-icon,
            .van-icon__image
                width 32rpx
                height 32rpx
            .van-cell__left-icon
                margin-right 10rpx
            .van-cell__title,
            .van-cell__value
                line-height 32rpx
            .van-cell__title
                font-size 16rpx
                color #333333
        >p
            font-size 14rpx
            line-height 24rpx
            color #7D7D7D
            margin-left 38rpx
            margin-right 16rpx
        .fileList
            margin-left 38rpx
            margin-right 16rpx
            li
                font-size 14rpx
                color #0189FC
                line-height 30rpx
                margin-bottom 5rpx
                span
                    display inline-block
                    height 30rpx
                    border-bottom 1px solid #0189FC
                i
                    font-size 14rpx
                    padding-left 5rpx
        .van-divider
            margin 0
            &:before
                border-width 30rpx 0 0
                border-color #F0F0F0
        dl
            padding 15rpx
            dt
                color #5588F1
                font-size 16rpx
                margin-bottom 10rpx
            dd
                font-size 14rpx
                line-height 24rpx
                padding-bottom 10rpx
                color #666666
                border-bottom 1px dashed #F0F0F0
                p
                    margin-left 42rpx
            .van-cell
                padding-left 0
                padding-right 0
        .textarea
            position relative
            &:before
                position absolute
                top 24rpx
                left 26rpx
            textarea
                text-indent 30rpx
                &.van-field__control
                    border 1px solid #D7D7D7
                    border-radius 4px
                    padding 10rpx
                    height 130rpx !important
                &::placeholder
                    color #D7D7D7
        >button
            width 60rpx
            height 30rpx
            border-radius 4rpx
            background #1577D2
            font-size 14rpx
            border none
            color #fff
            float right
            margin-right 16px
            margin-top 5px
</style>